import { AfterContentInit, Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

declare const hbspt: any;

@Component({
  selector: 'kt-wallet-activation-form',
  templateUrl: './wallet-activation-form.component.html',
  styleUrls: ['./wallet-activation-form.component.scss'],
  standalone: false,
})
export class WalletActivationFormComponent implements AfterContentInit {
  ngAfterContentInit() {
    hbspt?.forms?.create({
      portalId: environment.hubSpot.portalId,
      formId: environment.hubSpot.formId,
      target: '#cargoActivationForm',
      onFormSubmit($form) {
        console.log($form, '$form');
      },
    });
  }
}
